import { observer } from "mobx-react-lite";

import { twMerge } from "@/utils/twMerge";

import type { DecoratorNodeModel } from "@/models/nodes/DecoratorNodeModel";

type CancelType = "cancel" | "bcancel" | "xcancel";

type Props = {
  node: DecoratorNodeModel;
  isSelected?: boolean;
  type?: CancelType;
};

type CancelLinesProps = {
  isSelected?: boolean;
  type?: CancelType;
  className?: string;
};

export function CancelLines({ isSelected, type = "cancel", className }: CancelLinesProps) {
  return (
    <svg
      role="presentation"
      className={twMerge(
        "absolute inset-0 z-10 h-full w-full text-document-text overflow-visible",
        '[[data-change-request-part="before"]_[data-math]_&]:text-red-950 dark:[[data-change-request-part="before"]_[data-math]_&]:text-red-100',
        isSelected && "fromSm:text-icon-active",
        className,
      )}
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      strokeLinecap="round"
    >
      {(type === "cancel" || type === "xcancel") && (
        <line
          x1="99"
          y1="1"
          x2="1"
          y2="99"
          stroke="currentColor"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      )}
      {(type === "bcancel" || type === "xcancel") && (
        <line
          x1="1"
          y1="1"
          x2="99"
          y2="99"
          stroke="currentColor"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      )}
    </svg>
  );
}

export const Cancel = observer(function Cancel({
  node: _node,
  isSelected,
  type = "cancel",
}: Props) {
  return <CancelLines isSelected={isSelected} type={type} />;
});
